// This file is part of Moodle - http://moodle.org/
// Moodle is free software, distributed under the GNU GPL v3 or later.

/**
 * Standalone head entry point. Build this file; do not serve ES modules directly.
 *
 * @copyright 2020 Yogesh Shirsath <yogshirsath@hotmail.com>
 * @license http://www.gnu.org/copyleft/gpl.html GNU GPL v3 or later
 */

import {normaliseSettings, validPolicy} from '../amd/src/policy.js';
import {activate} from '../amd/src/engine.js';

try {
    const payload = JSON.parse(document.currentScript?.getAttribute('data-local-disablerightclick') || 'null');
    if (payload && Number.isInteger(payload.contextid) && payload.contextid > 0 && validPolicy(payload.policy) &&
            Array.isArray(payload.strings) && payload.strings.length >= 3 &&
            payload.strings.every(value => typeof value === 'string')) {
        activate(normaliseSettings(payload.policy.enabled ? payload.policy.settings : {}), payload.strings);
    }
} catch (error) {
    // Moodle's AMD fallback can retry and report initialization errors. Keep the page usable.
}
